import { ReactNode } from "react";
import styles from "./header.module.scss";
export default function Header({ children }: { children: ReactNode }) {
  return <h1 className={styles.header}>{children}</h1>;
}
